import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import API from 'core/api'
import { getConfig } from 'core/singleton'
import useDragElement from '../../core/hooks/useDragElement'
import SectionContent from 'components/Section/SectionContent'
import SauceClipCard from 'components/Card/SauceClipCard'
import LoadMoreCard from 'components/LoadMoreCard/LoadMoreCard'

export default function SectionSauceClip() {
  const [isLoading, setIsLoading] = useState(false)
  const [clipList, setClipList] = useState<ClipCurationData[]>([])
  const [page, setPage] = useState<number>(0)
  const config = getConfig()
  const { t } = useTranslation()

  const dragRef = useRef<HTMLDivElement | null>(null)
  useDragElement({
    targetElement: dragRef.current,
  })

  const getClipsData = async (targetPage: 1 | 2) => {
    setIsLoading(true)
    const data = await API.getClipsData(targetPage)
    const rows = data?.rows
    rows && setClipList((prev) => [...prev, ...rows])
    setIsLoading(false)
  }

  const handleClickLoadMore = () => {
    getClipsData(2)
    setPage(2)
  }

  useEffect(() => {
    getClipsData(1)
  }, [])

  if (!clipList || clipList.length < 1) return <></>
  return (
    <StyledSectionSauceClip>
      <SectionTitle>{config.sauceclip?.clipTitle || t('sauceclip_title')}</SectionTitle>
      <SectionContent>
        {clipList.map((data) => (
          <SauceClipCard data={data} key={data.id} />
        ))}
        {(page !== 2 || isLoading) && (
          <LoadMoreCard isLoading={isLoading} onClickLoadMore={handleClickLoadMore} />
        )}
      </SectionContent>
    </StyledSectionSauceClip>
  )
}

const StyledSectionSauceClip = styled.div`
  width: 100%;
  position: relative;
`
const SectionTitle = styled.p`
  line-height: 48px;
  font-weight: 700;
  font-size: 24px;
  position: relative;
  margin: 8px 0 0 0;
  padding: 12px 20px 8px 20px;
`
